import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Container } from '../../layout/Container'
import { Button } from '../../ui/Button'
import { ArrowRight } from 'lucide-react'

export function HowWeWorkCTA() {
  const { t } = useTranslation()

  return (
    <section className="relative overflow-hidden py-24">
      <div className="absolute inset-0 bg-grid opacity-50" />
      <Container size="narrow" className="relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-3xl border border-border-subtle bg-surface-elevated px-6 py-16 text-center sm:px-12"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-accent/10 via-transparent to-accent-light/5" />
          <div className="relative z-10">
            <h2 className="text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl">
              {t('howWeWorkPage.finalCta.headline')}
            </h2>
            <div className="mt-8">
              <Button asChild size="lg">
                <a href="/#diagnostico" className="group">
                  {t('howWeWorkPage.finalCta.button')}
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </a>
              </Button>
            </div>
          </div>
        </motion.div>
      </Container>
    </section>
  )
}
